// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useParams, useLocation, useNavigate } from "react-router-dom";
// import {
//   RiArrowLeftLine,
//   RiSplitCellsHorizontal,
//   RiFileTextLine,
//   RiBuilding2Line,
//   RiCalendarLine,
//   RiUserLine,
//   RiCloseLine,
//   RiCheckLine,
//   RiErrorWarningLine,
//   RiInboxLine,
//   RiPieChartLine,
//   RiHashtag,
//   RiFilePdf2Line,
//   RiArrowRightSLine,
//   RiRulerLine,
//   RiStackLine,
// } from "react-icons/ri";
// import { LiaRupeeSignSolid } from "react-icons/lia";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";
// import { generateBranchWiseSplitBillPDF } from "../Util/Branchwisesplitpdf";
// import {
//   generateSizeCalculationPDF,
//   generateSizeBranchSplitPDF,
// } from "../Util/Sizewisesplitpdf";

// const BASE_URL = process.env.REACT_APP_API_URL;

// const Spinner = ({ className = "w-4 h-4" }) => (
//   <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
// );

// const fmt = (n) =>
//   Number(n || 0).toLocaleString("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });

// const fmtDate = (d) =>
//   d
//     ? new Date(d).toLocaleDateString("en-IN", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       })
//     : "—";

// const normalizeSplit = (item, fallbackIndex) => {
//   const borrowers =
//     item.borrowers && item.borrowers.length > 0
//       ? item.borrowers
//       : [
//           {
//             borrowerName: Array.isArray(item.borrowersName)
//               ? item.borrowersName.join(", ")
//               : item.borrowersName || "—",
//             perAccount: item.perAcc || 0,
//             accountNumber: item.acc || 1,
//             subtotal: item.subTotal || item.branchSubtotal || 0,
//             cgst: item.cgst || item.branchCgst || 0,
//             sgst: item.sgst || item.branchSgst || 0,
//             total: item.total || item.branchTotal || 0,
//           },
//         ];

//   const subTotal =
//     item.branchSubtotal ?? borrowers.reduce((s, b) => s + (b.subtotal || 0), 0);
//   const cgst =
//     item.branchCgst ?? borrowers.reduce((s, b) => s + (b.cgst || 0), 0);
//   const sgst =
//     item.branchSgst ?? borrowers.reduce((s, b) => s + (b.sgst || 0), 0);
//   const total =
//     item.branchTotal ?? borrowers.reduce((s, b) => s + (b.total || 0), 0);

//   const acc = borrowers.reduce((s, b) => s + (b.accountNumber ?? 1), 0);
//   const perAcc = borrowers.reduce((s, b) => s + (Number(b.perAccount) || 0), 0);

//   return {
//     id: item.splitBillId || item._id || "",
//     displayIndex: item.index !== undefined ? item.index : fallbackIndex,
//     branchName: item.branchName || "—",
//     branchId:
//       item.branchId ||
//       (item.branch && typeof item.branch === "object"
//         ? item.branch._id
//         : item.branch) ||
//       null,
//     borrowers: borrowers.map((b) => ({
//       ...b,
//       perAccount: b.perAccount || 0,
//       accountNumber: b.accountNumber || 1,
//     })),
//     subTotal,
//     cgst,
//     sgst,
//     total,
//     acc,
//     perAcc,
//   };
// };

// /* ─── Toast ─── */
// const Toast = ({ message, type, onClose }) => {
//   useEffect(() => {
//     const t = setTimeout(onClose, 3500);
//     return () => clearTimeout(t);
//   }, [onClose]);

//   return (
//     <div
//       className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
//       ${
//         type === "success"
//           ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
//           : "bg-red-50 border border-red-200 text-red-800"
//       }`}
//     >
//       {type === "success" ? (
//         <RiCheckLine className="w-4 h-4 text-emerald-500" />
//       ) : (
//         <RiErrorWarningLine className="w-4 h-4 text-red-500" />
//       )}
//       <span>{message}</span>
//       <button
//         onClick={onClose}
//         className="ml-2 opacity-50 hover:opacity-100 transition"
//       >
//         <RiCloseLine className="w-4 h-4" />
//       </button>
//     </div>
//   );
// };

// /* ─── Stat Card ─── */
// const StatCard = ({
//   label,
//   value,
//   icon: Icon,
//   accent = "border-emerald-100",
// }) => (
//   <div
//     className={`bg-white border rounded-2xl px-5 py-4 flex items-center gap-4 shadow-sm ${accent}`}
//   >
//     <div className="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center flex-shrink-0">
//       <Icon className="w-5 h-5 text-emerald-600" />
//     </div>
//     <div>
//       <div className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
//         {label}
//       </div>
//       <div className="text-lg font-extrabold text-slate-800">{value}</div>
//     </div>
//   </div>
// );

// /* ─── Branch-wise PDF Buttons ─── */
// const PdfButton = ({ invoiceId, splitBillId, onError }) => {
//   const [loading, setLoading] = useState(false);
//   const handleClick = async (e) => {
//     e.stopPropagation();
//     setLoading(true);
//     try {
//       const firstRes = await axios.get(
//         `${BASE_URL}/splitsbill/${invoiceId}/split-bill/${splitBillId}`,
//       );
//       const firstData = firstRes.data?.data;
//       if (!firstData) throw new Error("No data returned from API");
//       const currentSplitBill = firstData.allSplitBills?.find(
//         (bill) => bill.splitBillId === splitBillId,
//       );
//       const branchId = currentSplitBill?.branchId;
//       if (!branchId) throw new Error("Branch ID not found");
//       const secondRes = await axios.get(
//         `${BASE_URL}/splitsbill/invoices/${invoiceId}/branches/${branchId}/split-bill`,
//       );
//       const pdfData = secondRes.data?.data;
//       if (!pdfData) throw new Error("No data returned from PDF API");
//       generateBranchWiseSplitBillPDF(pdfData);
//     } catch (err) {
//       onError(
//         err?.response?.data?.message ||
//           err?.message ||
//           "Failed to generate PDF.",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//     <button
//       onClick={handleClick}
//       disabled={loading}
//       className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border bg-red-50 border-red-200 text-red-600 hover:bg-red-600 hover:border-red-600 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-150 whitespace-nowrap"
//     >
//       {loading ? (
//         <Spinner className="w-3.5 h-3.5" />
//       ) : (
//         <RiFilePdf2Line className="w-3.5 h-3.5" />
//       )}
//       {loading ? "Generating…" : "PDF"}
//     </button>
//   );
// };

// const BranchPdfButton = ({
//   invoiceId,
//   branchId,
//   firstSplitBillId,
//   onError,
// }) => {
//   const [loading, setLoading] = useState(false);
//   const handleClick = async (e) => {
//     e.stopPropagation();
//     setLoading(true);
//     try {
//       let resolvedBranchId = branchId;
//       if (!resolvedBranchId || !/^[a-f\d]{24}$/i.test(resolvedBranchId)) {
//         const lookupRes = await axios.get(
//           `${BASE_URL}/splitsbill/${invoiceId}/split-bill/${firstSplitBillId}`,
//         );
//         const lookupData = lookupRes.data?.data;
//         if (!lookupData) throw new Error("No data returned from lookup API");
//         const found = lookupData.allSplitBills?.find(
//           (bill) => bill.splitBillId === firstSplitBillId,
//         );
//         resolvedBranchId = found?.branchId;
//         if (!resolvedBranchId) throw new Error("Branch ID not found");
//       }
//       const res = await axios.get(
//         `${BASE_URL}/splitsbill/invoices/${invoiceId}/branches/${resolvedBranchId}/split-bill`,
//       );
//       const pdfData = res.data?.data;
//       if (!pdfData) throw new Error("No data returned from PDF API");
//       generateBranchWiseSplitBillPDF(pdfData);
//     } catch (err) {
//       onError(
//         err?.response?.data?.message ||
//           err?.message ||
//           "Failed to generate branch PDF.",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//     <button
//       onClick={handleClick}
//       disabled={loading}
//       className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border bg-red-50 border-red-200 text-red-600 hover:bg-red-600 hover:border-red-600 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-150 whitespace-nowrap"
//     >
//       {loading ? (
//         <Spinner className="w-3.5 h-3.5" />
//       ) : (
//         <RiFilePdf2Line className="w-3.5 h-3.5" />
//       )}
//       {loading ? "Generating…" : "PDF"}
//     </button>
//   );
// };

// const BorrowerPdfButton = ({
//   invoiceId,
//   branchId,
//   firstSplitBillId,
//   borrower,
//   onError,
// }) => {
//   const [loading, setLoading] = useState(false);
//   const handleClick = async (e) => {
//     e.stopPropagation();
//     setLoading(true);
//     try {
//       let resolvedBranchId = branchId;
//       if (!resolvedBranchId || !/^[a-f\d]{24}$/i.test(resolvedBranchId)) {
//         const lookupRes = await axios.get(
//           `${BASE_URL}/splitsbill/${invoiceId}/split-bill/${firstSplitBillId}`,
//         );
//         const lookupData = lookupRes.data?.data;
//         if (!lookupData) throw new Error("No data returned from lookup API");
//         const found = lookupData.allSplitBills?.find(
//           (bill) => bill.splitBillId === firstSplitBillId,
//         );
//         resolvedBranchId = found?.branchId;
//         if (!resolvedBranchId) throw new Error("Branch ID not found");
//       }
//       const res = await axios.get(
//         `${BASE_URL}/splitsbill/invoices/${invoiceId}/branches/${resolvedBranchId}/split-bill`,
//       );
//       const pdfData = res.data?.data;
//       if (!pdfData) throw new Error("No data returned from PDF API");
//       const invoiceSubTotal = pdfData.invoice?.subTotal || 0;
//       const borrowerRatio =
//         invoiceSubTotal > 0 ? (borrower.subtotal || 0) / invoiceSubTotal : 0;
//       const borrowerPdfData = {
//         ...pdfData,
//         splitBill: {
//           ...pdfData.splitBill,
//           borrowers: [borrower],
//           subTotal: borrower.subtotal ?? 0,
//           cgst: borrower.cgst ?? 0,
//           sgst: borrower.sgst ?? 0,
//           total: borrower.total ?? 0,
//         },
//         items: {
//           ...pdfData.items,
//           allItems: (pdfData.items?.allItems || []).map((item) => ({
//             ...item,
//             splitAmount: Number(
//               ((item.originalAmount || 0) * borrowerRatio).toFixed(2),
//             ),
//           })),
//         },
//       };
//       generateBranchWiseSplitBillPDF(borrowerPdfData);
//     } catch (err) {
//       onError(
//         err?.response?.data?.message ||
//           err?.message ||
//           "Failed to generate borrower PDF.",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//     <button
//       onClick={handleClick}
//       disabled={loading}
//       className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border bg-red-50 border-red-200 text-red-600 hover:bg-red-600 hover:border-red-600 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-150 whitespace-nowrap"
//     >
//       {loading ? (
//         <Spinner className="w-3.5 h-3.5" />
//       ) : (
//         <RiFilePdf2Line className="w-3.5 h-3.5" />
//       )}
//       {loading ? "Generating…" : "PDF"}
//     </button>
//   );
// };

// /* ══════════════════════════════════════════════════════════════
//    SIZE-WISE PDF BUTTONS
// ══════════════════════════════════════════════════════════════ */
// const SizePdfBaseButton = ({
//   label,
//   icon: Icon,
//   loading,
//   onClick,
//   variant = "size",
// }) => {
//   const colors =
//     variant === "split"
//       ? "bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-600 hover:border-emerald-600 hover:text-white"
//       : "bg-indigo-50 border-indigo-200 text-indigo-700 hover:bg-indigo-600 hover:border-indigo-600 hover:text-white";

//   return (
//     <button
//       onClick={onClick}
//       disabled={loading}
//       className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border transition-all duration-150 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed ${colors}`}
//     >
//       {loading ? (
//         <Spinner className="w-3.5 h-3.5" />
//       ) : (
//         <Icon className="w-3.5 h-3.5" />
//       )}
//       {loading ? "Generating…" : label}
//     </button>
//   );
// };

// const SizeCalcPdfButton = ({ bill, invoiceData, onError }) => {
//   const [loading, setLoading] = useState(false);
//   const handleClick = (e) => {
//     e.stopPropagation();
//     setLoading(true);
//     try {
//       generateSizeCalculationPDF(bill, invoiceData || {});
//     } catch (err) {
//       onError(err?.message || "Failed to generate size calculation PDF.");
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//     <SizePdfBaseButton
//       label="Size PDF"
//       icon={RiRulerLine}
//       loading={loading}
//       onClick={handleClick}
//       variant="size"
//     />
//   );
// };

// const SizeSplitPdfButton = ({ bill, invoiceData, onError }) => {
//   const [loading, setLoading] = useState(false);
//   const handleClick = (e) => {
//     e.stopPropagation();
//     setLoading(true);
//     try {
//       generateSizeBranchSplitPDF(bill, invoiceData || {});
//     } catch (err) {
//       onError(err?.message || "Failed to generate split PDF.");
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//     <SizePdfBaseButton
//       label="Split PDF"
//       icon={RiSplitCellsHorizontal}
//       loading={loading}
//       onClick={handleClick}
//       variant="split"
//     />
//   );
// };

// /* ══════════════════════════════════════════════════════════════
//    SIZE ITEMS TAB
// ══════════════════════════════════════════════════════════════ */
// const SizeItemsTab = ({ invoiceId, notify }) => {
//   const [bills, setBills] = useState([]);
//   const [invoiceData, setInvoiceData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [expandedBills, setExpandedBills] = useState({});

//   useEffect(() => {
//     const fetchBills = async () => {
//       setLoading(true);
//       try {
//         const res = await axios.get(
//           `${BASE_URL}/size-wise-split/${invoiceId}/size-split-bills`,
//         );
//         const data = res.data?.data || {};
//         setBills(data.splitBills || []);
//         if (data.invoice) setInvoiceData(data.invoice);
//       } catch {
//         notify("Failed to load size-wise split bills", "error");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchBills();
//   }, [invoiceId]); // eslint-disable-line

//   const toggleBill = (id) =>
//     setExpandedBills((prev) => ({ ...prev, [id]: !prev[id] }));

//   if (loading) {
//     return (
//       <div className="flex flex-col items-center justify-center py-20 gap-3 text-indigo-400">
//         <Spinner className="w-8 h-8" />
//         <span className="text-xs font-medium">Loading size items…</span>
//       </div>
//     );
//   }

//   if (bills.length === 0) {
//     return (
//       <div className="bg-white border border-indigo-100 rounded-2xl shadow-sm flex flex-col items-center justify-center py-20 gap-3">
//         <RiInboxLine className="w-12 h-12 text-indigo-200" />
//         <p className="text-sm font-semibold text-slate-400">
//           No size-wise split bills found.
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div className="space-y-5">
//       {bills.map((bill, billIdx) => {
//         const isOpen = expandedBills[bill._id] !== false;
//         const hasBranches = bill.branches && bill.branches.length > 0;

//         return (
//           <div
//             key={bill._id || billIdx}
//             className="bg-white border border-indigo-100 rounded-2xl shadow-sm overflow-hidden"
//           >
//             {/* ── Bill header ── */}
//             <div className="flex items-center justify-between px-5 py-3.5 bg-indigo-50/60 border-b border-indigo-100">
//               <button
//                 onClick={() => toggleBill(bill._id)}
//                 className="flex items-center gap-3 text-left flex-1 min-w-0 hover:opacity-80 transition"
//               >
//                 <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center text-white flex-shrink-0">
//                   <RiRulerLine className="w-3.5 h-3.5" />
//                 </div>
//                 <div>
//                   <span className="text-sm font-bold text-indigo-800">
//                     Bill #{bill.billNumber}
//                   </span>
//                   <span className="ml-2 text-[10px] text-indigo-400 font-mono">
//                     {bill.sizeItems?.length || 0} size row
//                     {bill.sizeItems?.length !== 1 ? "s" : ""}
//                     {hasBranches &&
//                       ` · ${bill.branches.length} branch${bill.branches.length !== 1 ? "es" : ""}`}
//                   </span>
//                 </div>
//               </button>

//               <div className="hidden sm:flex items-center gap-4 mr-3">
//                 {[
//                   { label: "Sub Total", value: bill.grandSubTotal },
//                   { label: "CGST", value: bill.grandCgst },
//                   { label: "SGST", value: bill.grandSgst },
//                   { label: "Total", value: bill.grandTotal, bold: true },
//                 ].map(({ label, value, bold }) => (
//                   <div key={label} className="text-right">
//                     <div className="text-[9px] text-slate-400 uppercase tracking-widest">
//                       {label}
//                     </div>
//                     <div
//                       className={`text-xs font-mono ${bold ? "font-extrabold text-indigo-700" : "font-semibold text-slate-700"}`}
//                     >
//                       ₹{fmt(value)}
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               <div className="flex items-center gap-2 flex-shrink-0">
//                 {bill.sizeItems?.length > 0 && (
//                   <SizeCalcPdfButton
//                     bill={bill}
//                     invoiceData={invoiceData}
//                     onError={(msg) => notify(msg, "error")}
//                   />
//                 )}
//                 {hasBranches && (
//                   <SizeSplitPdfButton
//                     bill={bill}
//                     invoiceData={invoiceData}
//                     onError={(msg) => notify(msg, "error")}
//                   />
//                 )}
//                 <button
//                   onClick={() => toggleBill(bill._id)}
//                   className="ml-1 p-1 rounded-lg hover:bg-indigo-100 transition"
//                 >
//                   <RiArrowRightSLine
//                     className={`w-4 h-4 text-indigo-400 transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`}
//                   />
//                 </button>
//               </div>
//             </div>

//             {isOpen && (
//               <>
//                 {/* ── Size Items table ── */}
//                 <div className="px-5 pt-4 pb-2">
//                   <div className="flex items-center gap-2 mb-2">
//                     <RiRulerLine className="w-3.5 h-3.5 text-indigo-400" />
//                     <span className="text-[10px] font-bold text-indigo-600 uppercase tracking-widest">
//                       Size Calculation Rows
//                     </span>
//                   </div>
//                 </div>

//                 <div className="overflow-x-auto">
//                   <table className="w-full text-xs">
//                     <thead>
//                       <tr className="border-b border-indigo-50 bg-indigo-50/40">
//                         {[
//                           "#",
//                           "Height",
//                           "Common",
//                           "Total Ht.",
//                           "Width",
//                           "Area (SqCm)",
//                           "Rate",
//                           "Sub Total",
//                           "CGST",
//                           "SGST",
//                           "Total",
//                         ].map((h) => (
//                           <th
//                             key={h}
//                             className="px-4 py-2.5 text-left text-[10px] font-semibold text-indigo-500 uppercase tracking-widest whitespace-nowrap"
//                           >
//                             {h}
//                           </th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {(bill.sizeItems || []).map((item, i) => (
//                         <tr
//                           key={item._id || i}
//                           className="border-b border-slate-50 hover:bg-indigo-50/10 transition"
//                         >
//                           <td className="px-4 py-2.5 text-slate-400 font-mono">
//                             {i + 1}
//                           </td>
//                           <td className="px-4 py-2.5 font-mono text-slate-700">
//                             {item.height}
//                           </td>
//                           <td className="px-4 py-2.5 font-mono text-slate-500">
//                             {item.common}
//                           </td>
//                           <td className="px-4 py-2.5 font-mono font-semibold text-indigo-700">
//                             {item.totalHeight}
//                           </td>
//                           <td className="px-4 py-2.5 font-mono text-slate-700">
//                             {item.width}
//                           </td>
//                           <td className="px-4 py-2.5 font-mono font-semibold text-slate-700">
//                             {fmt(item.area)}
//                           </td>
//                           <td className="px-4 py-2.5 font-mono text-slate-600">
//                             ₹{fmt(item.rate)}
//                           </td>
//                           <td className="px-4 py-2.5 font-mono text-slate-700">
//                             ₹{fmt(item.subTotal)}
//                           </td>
//                           <td className="px-4 py-2.5 font-mono text-slate-500">
//                             ₹{fmt(item.cgst)}
//                           </td>
//                           <td className="px-4 py-2.5 font-mono text-slate-500">
//                             ₹{fmt(item.sgst)}
//                           </td>
//                           <td className="px-4 py-2.5 font-mono font-extrabold text-indigo-700">
//                             ₹{fmt(item.total)}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                     <tfoot>
//                       <tr className="bg-indigo-50/60 border-t-2 border-indigo-100">
//                         <td
//                           colSpan={7}
//                           className="px-4 py-2.5 text-[10px] font-bold text-indigo-600 uppercase tracking-widest"
//                         >
//                           Grand Total ({bill.sizeItems?.length || 0} rows)
//                         </td>
//                         <td className="px-4 py-2.5 font-bold font-mono text-slate-700">
//                           ₹{fmt(bill.grandSubTotal)}
//                         </td>
//                         <td className="px-4 py-2.5 font-bold font-mono text-slate-700">
//                           ₹{fmt(bill.grandCgst)}
//                         </td>
//                         <td className="px-4 py-2.5 font-bold font-mono text-slate-700">
//                           ₹{fmt(bill.grandSgst)}
//                         </td>
//                         <td className="px-4 py-2.5 font-extrabold font-mono text-indigo-700 text-sm">
//                           ₹{fmt(bill.grandTotal)}
//                         </td>
//                       </tr>
//                     </tfoot>
//                   </table>
//                 </div>

//                 {/* ── Branch & Borrower Allocation ── */}
//                 {hasBranches && (
//                   <>
//                     <div className="px-5 pt-4 pb-2 border-t border-slate-100 mt-2">
//                       <div className="flex items-center gap-2 mb-2">
//                         <RiBuilding2Line className="w-3.5 h-3.5 text-emerald-500" />
//                         <span className="text-[10px] font-bold text-emerald-600 uppercase tracking-widest">
//                           Branch &amp; Borrower Allocation
//                         </span>
//                       </div>
//                     </div>

//                     <div className="overflow-x-auto pb-4">
//                       <table className="w-full text-xs">
//                         <thead>
//                           <tr className="border-b border-emerald-50 bg-emerald-50/40">
//                             {[
//                               "#",
//                               "Branch",
//                               "Borrower",
//                               "Sub Total",
//                               "CGST",
//                               "SGST",
//                               "Total",
//                             ].map((h) => (
//                               <th
//                                 key={h}
//                                 className="px-4 py-2.5 text-left text-[10px] font-semibold text-emerald-500 uppercase tracking-widest whitespace-nowrap"
//                               >
//                                 {h}
//                               </th>
//                             ))}
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {bill.branches.map((branch, bi) =>
//                             (branch.borrowers || []).map((borrower, bwi) => (
//                               <tr
//                                 key={`${bi}-${bwi}`}
//                                 className="border-b border-slate-50 hover:bg-emerald-50/10 transition"
//                               >
//                                 <td className="px-4 py-2.5 text-slate-400 font-mono">
//                                   {bi + 1}.{bwi + 1}
//                                 </td>
//                                 <td className="px-4 py-2.5">
//                                   {bwi === 0 ? (
//                                     <div className="flex items-center gap-1.5">
//                                       <RiBuilding2Line className="w-3 h-3 text-emerald-400 flex-shrink-0" />
//                                       <span className="font-semibold text-slate-700 whitespace-nowrap">
//                                         {branch.branchName}
//                                       </span>
//                                       {branch.borrowers.length > 1 && (
//                                         <span className="ml-1 px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-emerald-50 border border-emerald-200 text-emerald-600">
//                                           {branch.borrowers.length}
//                                         </span>
//                                       )}
//                                     </div>
//                                   ) : (
//                                     <span className="text-slate-300 pl-5">
//                                       ↳
//                                     </span>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-2.5">
//                                   <div className="flex items-center gap-1.5">
//                                     <RiUserLine className="w-3 h-3 text-emerald-300 flex-shrink-0" />
//                                     <span className="text-slate-600">
//                                       {borrower.borrowerName || "—"}
//                                     </span>
//                                   </div>
//                                 </td>
//                                 <td className="px-4 py-2.5 font-mono text-slate-700">
//                                   ₹{fmt(borrower.subtotal)}
//                                 </td>
//                                 <td className="px-4 py-2.5 font-mono text-slate-500">
//                                   ₹{fmt(borrower.cgst)}
//                                 </td>
//                                 <td className="px-4 py-2.5 font-mono text-slate-500">
//                                   ₹{fmt(borrower.sgst)}
//                                 </td>
//                                 <td className="px-4 py-2.5 font-mono font-extrabold text-emerald-700">
//                                   ₹{fmt(borrower.total)}
//                                 </td>
//                               </tr>
//                             )),
//                           )}
//                         </tbody>
//                         <tfoot>
//                           <tr className="bg-emerald-50/60 border-t-2 border-emerald-100">
//                             <td
//                               colSpan={3}
//                               className="px-4 py-2.5 text-[10px] font-bold text-emerald-600 uppercase tracking-widest"
//                             >
//                               Bill Total (
//                               {bill.branches.reduce(
//                                 (s, b) => s + (b.borrowers?.length || 0),
//                                 0,
//                               )}{" "}
//                               borrowers)
//                             </td>
//                             <td className="px-4 py-2.5 font-bold font-mono text-slate-700">
//                               ₹{fmt(bill.grandSubTotal)}
//                             </td>
//                             <td className="px-4 py-2.5 font-bold font-mono text-slate-700">
//                               ₹{fmt(bill.grandCgst)}
//                             </td>
//                             <td className="px-4 py-2.5 font-bold font-mono text-slate-700">
//                               ₹{fmt(bill.grandSgst)}
//                             </td>
//                             <td className="px-4 py-2.5 font-extrabold font-mono text-emerald-700 text-sm">
//                               ₹{fmt(bill.grandTotal)}
//                             </td>
//                           </tr>
//                         </tfoot>
//                       </table>
//                     </div>
//                   </>
//                 )}

//                 {(bill.selectedBank?.branchName ||
//                   bill.selectedQuery?.contactPersonName) && (
//                   <div className="px-5 py-3 bg-slate-50 border-t border-slate-100 flex flex-wrap gap-6 text-[10px] text-slate-500">
//                     {bill.selectedBank?.branchName && (
//                       <div className="flex items-center gap-1.5">
//                         <span className="font-bold text-slate-600">
//                           {bill.selectedBank.branchName}
//                         </span>
//                         <span className="text-slate-300">·</span>
//                         <span>{bill.selectedBank.accountNumber}</span>
//                         <span className="text-slate-300">·</span>
//                         <span>{bill.selectedBank.ifscCode}</span>
//                       </div>
//                     )}
//                     {bill.selectedQuery?.contactPersonName && (
//                       <div className="flex items-center gap-1.5">
//                         <span>{bill.selectedQuery.contactPersonName}</span>
//                         <span className="text-slate-300">·</span>
//                         <span>{bill.selectedQuery.phone}</span>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// /* ══════════════════════════════════════════════════════════════
//    BRANCH SPLITS TAB
// ══════════════════════════════════════════════════════════════ */
// const BranchSplitsTab = ({ splits, summary, invoiceId, notify }) => {
//   const [expandedBranches, setExpandedBranches] = useState({});
//   const toggleBranch = (splitId) =>
//     setExpandedBranches((prev) => ({ ...prev, [splitId]: !prev[splitId] }));

//   const totalSplitAmount = splits.reduce((s, b) => s + b.total, 0);

//   if (splits.length === 0) {
//     return (
//       <div className="bg-white border border-emerald-100 rounded-2xl shadow-sm flex flex-col items-center justify-center py-20 gap-3">
//         <RiInboxLine className="w-12 h-12 text-emerald-200" />
//         <p className="text-sm font-semibold text-slate-400">
//           No branch split bills found.
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-white border border-emerald-100 rounded-2xl shadow-sm overflow-hidden">
//       <div className="px-5 py-3 border-b border-emerald-100 bg-emerald-50 flex items-center justify-between">
//         <div className="flex items-center gap-2">
//           <RiSplitCellsHorizontal className="w-4 h-4 text-emerald-500" />
//           <span className="text-xs font-bold text-emerald-700 uppercase tracking-widest">
//             Branch Split Bills ({splits.length})
//           </span>
//         </div>
//         {summary && (
//           <span className="text-[10px] text-slate-400 font-medium">
//             Remaining:{" "}
//             <span
//               className={`font-bold ${summary.remainingAmount === 0 ? "text-emerald-600" : "text-amber-600"}`}
//             >
//               ₹{fmt(summary.remainingAmount)}
//             </span>
//           </span>
//         )}
//       </div>

//       <div className="overflow-x-auto">
//         <table className="w-full text-sm">
//           <thead>
//             <tr className="border-b border-emerald-100 bg-emerald-50/40">
//               {[
//                 "#",
//                 "Branch / Borrowers",
//                 "Accounts",
//                 "Sub Total",
//                 "CGST",
//                 "SGST",
//                 "Total",
//                 "PDF",
//               ].map((h) => (
//                 <th
//                   key={h}
//                   className="px-4 py-3 text-left text-[10px] font-semibold text-emerald-500 uppercase tracking-widest whitespace-nowrap"
//                 >
//                   {h}
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {splits.map((split, gIdx) => {
//               const multi = split.borrowers.length > 1;
//               const isOpen = !!expandedBranches[split.id];
//               return (
//                 <React.Fragment key={split.id || gIdx}>
//                   <tr
//                     onClick={() => multi && toggleBranch(split.id)}
//                     className={`border-b border-emerald-50 transition-colors ${
//                       multi
//                         ? "cursor-pointer bg-emerald-50/20 hover:bg-emerald-50/50 select-none"
//                         : "hover:bg-emerald-50/20"
//                     }`}
//                   >
//                     <td className="px-4 py-3 text-xs text-slate-400 font-mono">
//                       {gIdx + 1}
//                     </td>
//                     <td className="px-4 py-3">
//                       <div className="flex items-center gap-1.5">
//                         {multi ? (
//                           <RiArrowRightSLine
//                             className={`w-4 h-4 text-emerald-400 flex-shrink-0 transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`}
//                           />
//                         ) : (
//                           <span className="w-4 flex-shrink-0" />
//                         )}
//                         <RiBuilding2Line className="w-3.5 h-3.5 text-emerald-300 flex-shrink-0" />
//                         <span className="text-xs font-semibold text-slate-700 whitespace-nowrap max-w-[140px] truncate">
//                           {split.branchName}
//                         </span>
//                         {multi && (
//                           <span className="ml-1 inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-blue-50 border border-blue-200 text-blue-600 whitespace-nowrap">
//                             {split.borrowers.length} borrowers
//                           </span>
//                         )}
//                         {!multi && (
//                           <span className="ml-2 flex items-center gap-1 text-xs text-slate-500">
//                             <RiUserLine className="w-3.5 h-3.5 text-emerald-300 flex-shrink-0" />
//                             <span className="truncate max-w-[120px]">
//                               {split.borrowers[0]?.borrowerName || "—"}
//                             </span>
//                           </span>
//                         )}
//                       </div>
//                     </td>
//                     <td className="px-4 py-3 text-xs font-mono text-slate-600">
//                       {split.acc.toLocaleString("en-IN")}
//                     </td>
//                     <td className="px-4 py-3 text-xs font-mono text-slate-600">
//                       ₹{fmt(split.subTotal)}
//                     </td>
//                     <td className="px-4 py-3 text-xs font-mono text-slate-500">
//                       ₹{fmt(split.cgst)}
//                     </td>
//                     <td className="px-4 py-3 text-xs font-mono text-slate-500">
//                       ₹{fmt(split.sgst)}
//                     </td>
//                     <td className="px-4 py-3 whitespace-nowrap">
//                       <span className="font-extrabold text-emerald-700 font-mono text-sm">
//                         ₹{fmt(split.total)}
//                       </span>
//                     </td>
//                     <td className="px-4 py-3">
//                       {multi ? (
//                         <BranchPdfButton
//                           invoiceId={invoiceId}
//                           branchId={split.branchId}
//                           firstSplitBillId={split.id}
//                           onError={(msg) => notify(msg, "error")}
//                         />
//                       ) : (
//                         <PdfButton
//                           invoiceId={invoiceId}
//                           splitBillId={split.id}
//                           onError={(msg) => notify(msg, "error")}
//                         />
//                       )}
//                     </td>
//                   </tr>
//                   {multi &&
//                     isOpen &&
//                     split.borrowers.map((b, bi) => (
//                       <tr
//                         key={bi}
//                         className="border-b border-blue-50 bg-blue-50/20 hover:bg-blue-50/40 transition-colors"
//                       >
//                         <td className="px-4 py-2.5 text-[10px] text-slate-400 font-mono">
//                           {gIdx + 1}.{bi + 1}
//                         </td>
//                         <td className="px-4 py-2.5">
//                           <div className="flex items-center gap-1.5 pl-9">
//                             <RiUserLine className="w-3 h-3 text-emerald-300 flex-shrink-0" />
//                             <span className="text-xs text-slate-600 whitespace-nowrap max-w-[130px] truncate">
//                               {b.borrowerName}
//                             </span>
//                           </div>
//                         </td>
//                         <td className="px-4 py-2.5 text-xs font-mono text-slate-600">
//                           {Number(b.accountNumber).toLocaleString("en-IN")}
//                         </td>
//                         <td className="px-4 py-2.5 text-xs font-mono text-slate-600">
//                           ₹{fmt(b.subtotal)}
//                         </td>
//                         <td className="px-4 py-2.5 text-xs font-mono text-slate-500">
//                           ₹{fmt(b.cgst)}
//                         </td>
//                         <td className="px-4 py-2.5 text-xs font-mono text-slate-500">
//                           ₹{fmt(b.sgst)}
//                         </td>
//                         <td className="px-4 py-2.5 whitespace-nowrap">
//                           <span className="font-bold text-emerald-700 font-mono text-xs">
//                             ₹{fmt(b.total)}
//                           </span>
//                         </td>
//                         <td className="px-4 py-2.5">
//                           <BorrowerPdfButton
//                             invoiceId={invoiceId}
//                             branchId={split.branchId}
//                             firstSplitBillId={split.id}
//                             borrower={b}
//                             onError={(msg) => notify(msg, "error")}
//                           />
//                         </td>
//                       </tr>
//                     ))}
//                 </React.Fragment>
//               );
//             })}
//           </tbody>
//           <tfoot>
//             <tr className="bg-emerald-50/60 border-t-2 border-emerald-100">
//               <td
//                 colSpan={2}
//                 className="px-4 py-3 text-xs font-bold text-emerald-700 uppercase tracking-widest"
//               >
//                 Totals ({splits.length} split{splits.length !== 1 ? "s" : ""})
//               </td>
//               <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700">
//                 {splits.reduce((s, b) => s + b.acc, 0).toLocaleString("en-IN")}
//               </td>
//               <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700">
//                 ₹
//                 {fmt(
//                   summary?.totalSubTotal ??
//                     splits.reduce((s, b) => s + b.subTotal, 0),
//                 )}
//               </td>
//               <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700">
//                 ₹
//                 {fmt(
//                   summary?.totalCGST ?? splits.reduce((s, b) => s + b.cgst, 0),
//                 )}
//               </td>
//               <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700">
//                 ₹
//                 {fmt(
//                   summary?.totalSGST ?? splits.reduce((s, b) => s + b.sgst, 0),
//                 )}
//               </td>
//               <td className="px-4 py-3">
//                 <span className="font-extrabold text-emerald-800 font-mono text-base">
//                   ₹{fmt(summary?.totalAmount ?? totalSplitAmount)}
//                 </span>
//               </td>
//               <td />
//             </tr>
//           </tfoot>
//         </table>
//       </div>
//     </div>
//   );
// };

// /* ══════════════════════════════════════════════════════════════
//    MAIN COMPONENT
// ══════════════════════════════════════════════════════════════ */
// const TABS = [
//   { id: "branch", label: "Branch Splits", icon: RiSplitCellsHorizontal },
//   { id: "size", label: "Size Items", icon: RiRulerLine },
// ];

// const SplitBillDetails = () => {
//   const { id } = useParams();
//   const { state } = useLocation();
//   const navigate = useNavigate();

//   const invoiceData = state?.invoiceData || null;

//   const [splits, setSplits] = useState([]);
//   const [summary, setSummary] = useState(null);
//   const [invoice, setInvoice] = useState(invoiceData);
//   const [loading, setLoading] = useState(true);
//   const [toast, setToast] = useState(null);
//   const [activeTab, setActiveTab] = useState("branch");

//   const notify = (message, type = "success") => setToast({ message, type });

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${BASE_URL}/splitsbill/${id}/split-bills`);
//       const raw = res.data?.data || {};

//       if (raw.invoice) setInvoice(raw.invoice);

//       const type = raw.splitBillType;

//       if (type === "branch" || type === "both") {
//         // Populate branch splits; for "both", size tab fetches independently
//         const rawList = raw.allSplitBills || raw.splitBills || [];
//         setSplits(rawList.map((item, i) => normalizeSplit(item, i)));
//         if (raw.summary) setSummary(raw.summary);
//         // Default to branch tab (user can switch to size tab if "both")
//         setActiveTab("branch");
//       } else if (type === "size") {
//         // Pure size — branch tab has nothing to show, start on size tab
//         setSplits([]);
//         setSummary(null);
//         setActiveTab("size");
//       } else {
//         setSplits([]);
//         setSummary(null);
//       }
//     } catch {
//       notify("Failed to load split bills for this invoice", "error");
//     } finally {
//       setLoading(false);
//     }
//   }, [id]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   const inv = invoice;
//   const totalSplitAmount = splits.reduce((s, b) => s + b.total, 0);
//   const totalAccounts = splits.reduce((s, b) => s + b.acc, 0);

//   const splitBillType = inv?.splitBillType;

//   // "branch"  → only Branch Splits tab
//   // "size"    → only Size Items tab
//   // "both"    → both tabs (falls through to TABS)
//   // anything else → both tabs
//   const visibleTabs =
//     splitBillType === "branch"
//       ? TABS.filter((t) => t.id === "branch")
//       : splitBillType === "size"
//         ? TABS.filter((t) => t.id === "size")
//         : TABS;

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-slate-50 flex items-center justify-center">
//         <div className="flex flex-col items-center gap-4 text-emerald-400">
//           <Spinner className="w-10 h-10" />
//           <span className="text-sm font-medium">
//             Loading split bill details…
//           </span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-slate-50 text-slate-800">
//       {/* Header */}
//       <header className="bg-white border-b border-emerald-100 sticky top-0 z-30 shadow-sm">
//         <div className="w-full px-6 py-3.5 flex items-center gap-4 flex-wrap">
//           <button
//             onClick={() => navigate(-1)}
//             className="flex items-center justify-center w-9 h-9 rounded-xl border border-emerald-200 bg-emerald-50 text-emerald-600 hover:bg-emerald-100 transition flex-shrink-0"
//           >
//             <RiArrowLeftLine className="w-4 h-4" />
//           </button>

//           <div className="flex items-center gap-3 flex-1 min-w-0">
//             <div className="w-10 h-10 rounded-xl bg-emerald-600 flex items-center justify-center text-white shadow-md shadow-emerald-200 flex-shrink-0">
//               <RiSplitCellsHorizontal className="w-5 h-5" />
//             </div>
//             <div className="min-w-0">
//               <h1 className="text-base font-bold text-emerald-800 tracking-tight">
//                 Split Bill Details
//                 {inv?.invoiceNumber && (
//                   <span className="ml-2 text-emerald-500 font-mono text-sm">
//                     — {inv.invoiceNumber}
//                   </span>
//                 )}
//               </h1>
//               <p className="text-[11px] text-emerald-400 tracking-widest uppercase">
//                 {inv?.releaseOrder?.roNumber
//                   ? `RO: ${inv.releaseOrder.roNumber}`
//                   : "Invoice Split Bills"}
//               </p>
//             </div>
//           </div>

//           <div className="hidden sm:flex items-center gap-2 flex-wrap">
//             {inv?.splitBillType && (
//               <span className="inline-flex items-center gap-1 px-3 py-1.5 bg-indigo-50 border border-indigo-200 rounded-full text-xs font-bold text-indigo-700 capitalize">
//                 <RiStackLine className="w-3 h-3" />
//                 {inv.splitBillType === "both"
//                   ? "Branch + Size"
//                   : `${inv.splitBillType}-wise`}
//               </span>
//             )}
//             {inv?.splitBillStatus && (
//               <span className="inline-flex items-center gap-1 px-3 py-1.5 bg-emerald-100 border border-emerald-200 rounded-full text-xs font-bold text-emerald-700">
//                 <RiCheckLine className="w-3 h-3" />
//                 {inv.splitBillStatus.charAt(0).toUpperCase() +
//                   inv.splitBillStatus.slice(1)}
//               </span>
//             )}
//             {inv?.date && (
//               <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-slate-50 border border-slate-200 rounded-full text-xs font-semibold text-slate-600">
//                 <RiCalendarLine className="w-3.5 h-3.5 text-slate-400" />
//                 {fmtDate(inv.date)}
//               </span>
//             )}
//           </div>
//         </div>
//       </header>

//       <div className="px-6 py-6 space-y-5 w-full">
//         {/* Invoice Summary */}
//         {inv && (
//           <div className="bg-white border border-emerald-100 rounded-2xl shadow-sm overflow-hidden">
//             <div className="px-5 py-3 bg-emerald-50 border-b border-emerald-100 flex items-center gap-2">
//               <RiFileTextLine className="w-4 h-4 text-emerald-500" />
//               <span className="text-xs font-bold text-emerald-700 uppercase tracking-widest">
//                 Invoice Summary
//               </span>
//             </div>
//             <div className="px-5 py-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-8 gap-y-4">
//               {[
//                 { label: "Invoice No.", value: inv.invoiceNumber, mono: true },
//                 { label: "Date", value: fmtDate(inv.date || inv.createdAt) },
//                 {
//                   label: "Sub Total",
//                   value: `₹${fmt(inv.subTotal)}`,
//                   mono: true,
//                 },
//                 {
//                   label: "CGST",
//                   value: `₹${fmt(inv.cgstAmount)}`,
//                   sub: `${inv.cgstRate}%`,
//                   mono: true,
//                 },
//                 {
//                   label: "SGST",
//                   value: `₹${fmt(inv.sgstAmount)}`,
//                   sub: `${inv.sgstRate}%`,
//                   mono: true,
//                 },
//               ].map(({ label, value, sub, mono }) => (
//                 <div key={label}>
//                   <div className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-0.5">
//                     {label}
//                   </div>
//                   <div
//                     className={`text-sm font-bold text-slate-800 ${mono ? "font-mono" : ""}`}
//                   >
//                     {value}
//                   </div>
//                   {sub && (
//                     <div className="text-[10px] text-slate-400">{sub}</div>
//                   )}
//                 </div>
//               ))}
//             </div>
//             <div className="px-5 py-3 bg-emerald-600 flex items-center justify-between">
//               <span className="text-xs font-bold text-emerald-100 uppercase tracking-widest">
//                 Total Invoice Amount
//               </span>
//               <span className="text-lg font-extrabold text-white font-mono">
//                 ₹{fmt(inv.totalAmount)}
//               </span>
//             </div>
//           </div>
//         )}

//         {/* Stat Cards — only shown when branch data is present */}
//         {splits.length > 0 && (
//           <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
//             <StatCard
//               label="Total Splits"
//               value={summary?.totalSplitBills ?? splits.length}
//               icon={RiSplitCellsHorizontal}
//             />
//             <StatCard
//               label="Total Accounts"
//               value={totalAccounts.toLocaleString("en-IN")}
//               icon={RiHashtag}
//             />
//             <StatCard
//               label="Split Amount"
//               value={`₹${fmt(summary?.totalAmount ?? totalSplitAmount)}`}
//               icon={LiaRupeeSignSolid}
//             />
//             <StatCard
//               label="Remaining"
//               value={`₹${fmt(summary?.remainingAmount ?? 0)}`}
//               icon={RiPieChartLine}
//               accent={
//                 (summary?.remainingAmount ?? 0) === 0
//                   ? "border-emerald-200"
//                   : "border-amber-200"
//               }
//             />
//           </div>
//         )}

//         {/* Tabs */}
//         {visibleTabs.length > 1 && (
//           <div className="flex items-center gap-1 bg-white border border-slate-200 rounded-xl p-1 w-fit shadow-sm">
//             {visibleTabs.map((tab) => {
//               const Icon = tab.icon;
//               const active = activeTab === tab.id;
//               return (
//                 <button
//                   key={tab.id}
//                   onClick={() => setActiveTab(tab.id)}
//                   className={`flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-bold transition-all duration-150
//                     ${
//                       active
//                         ? tab.id === "size"
//                           ? "bg-indigo-600 text-white shadow-sm"
//                           : "bg-emerald-600 text-white shadow-sm"
//                         : "text-slate-500 hover:text-slate-700 hover:bg-slate-50"
//                     }`}
//                 >
//                   <Icon className="w-3.5 h-3.5" />
//                   {tab.label}
//                   {tab.id === "branch" && splits.length > 0 && (
//                     <span
//                       className={`px-1.5 py-0.5 rounded-full text-[10px] font-extrabold
//                       ${active ? "bg-white/20 text-white" : "bg-slate-100 text-slate-500"}`}
//                     >
//                       {splits.length}
//                     </span>
//                   )}
//                 </button>
//               );
//             })}
//           </div>
//         )}

//         {/* Tab content */}
//         {activeTab === "branch" && (
//           <BranchSplitsTab
//             splits={splits}
//             summary={summary}
//             invoiceId={id}
//             notify={notify}
//           />
//         )}
//         {activeTab === "size" && (
//           <SizeItemsTab invoiceId={id} notify={notify} />
//         )}
//       </div>

//       {toast && <Toast {...toast} onClose={() => setToast(null)} />}
//     </div>
//   );
// };

// export default SplitBillDetails;

import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import {
  RiArrowLeftLine,
  RiSplitCellsHorizontal,
  RiFileTextLine,
  RiBuilding2Line,
  RiCalendarLine,
  RiUserLine,
  RiCloseLine,
  RiCheckLine,
  RiErrorWarningLine,
  RiInboxLine,
  RiPieChartLine,
  RiHashtag,
  RiFilePdf2Line,
  RiArrowRightSLine,
  RiRulerLine,
  RiStackLine,
  RiArrowDownSLine,
  RiTableLine,
} from "react-icons/ri";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import {
  generateBranchWiseSplitBillPDF,
  BRANCH_SPLIT_IMAGE_BASE64,
} from "../Util/Branchwisesplitpdf";
import {
  generateSizeCalculationPDF,
  generateSizeBranchSplitPDF,
} from "../Util/Sizewisesplitpdf";
import {
  generateBranchWiseSplitBillPDFNoTable,
  setLetterheadBase64,
} from "../Util/Branchwisesplitpdf_notable";

// Seed the no-table generator with the same letterhead used everywhere else.
setLetterheadBase64(BRANCH_SPLIT_IMAGE_BASE64);

const BASE_URL = process.env.REACT_APP_API_URL;

const Spinner = ({ className = "w-4 h-4" }) => (
  <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
);

const fmt = (n) =>
  Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "—";

const normalizeSplit = (item, fallbackIndex) => {
  const borrowers =
    item.borrowers && item.borrowers.length > 0
      ? item.borrowers
      : [
          {
            borrowerName: Array.isArray(item.borrowersName)
              ? item.borrowersName.join(", ")
              : item.borrowersName || "—",
            perAccount: item.perAcc || 0,
            accountNumber: item.acc || 1,
            subtotal: item.subTotal || item.branchSubtotal || 0,
            cgst: item.cgst || item.branchCgst || 0,
            sgst: item.sgst || item.branchSgst || 0,
            total: item.total || item.branchTotal || 0,
          },
        ];

  const subTotal =
    item.branchSubtotal ?? borrowers.reduce((s, b) => s + (b.subtotal || 0), 0);
  const cgst =
    item.branchCgst ?? borrowers.reduce((s, b) => s + (b.cgst || 0), 0);
  const sgst =
    item.branchSgst ?? borrowers.reduce((s, b) => s + (b.sgst || 0), 0);
  const total =
    item.branchTotal ?? borrowers.reduce((s, b) => s + (b.total || 0), 0);

  const acc = borrowers.reduce((s, b) => s + (b.accountNumber ?? 1), 0);
  const perAcc = borrowers.reduce((s, b) => s + (Number(b.perAccount) || 0), 0);

  return {
    id: item.splitBillId || item._id || "",
    displayIndex: item.index !== undefined ? item.index : fallbackIndex,
    branchName: item.branchName || "—",
    branchId:
      item.branchId ||
      (item.branch && typeof item.branch === "object"
        ? item.branch._id
        : item.branch) ||
      null,
    borrowers: borrowers.map((b) => ({
      ...b,
      perAccount: b.perAccount || 0,
      accountNumber: b.accountNumber || 1,
    })),
    subTotal,
    cgst,
    sgst,
    total,
    acc,
    perAcc,
  };
};

/* ─── Toast ─── */
const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
      ${
        type === "success"
          ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
          : "bg-red-50 border border-red-200 text-red-800"
      }`}
    >
      {type === "success" ? (
        <RiCheckLine className="w-4 h-4 text-emerald-500" />
      ) : (
        <RiErrorWarningLine className="w-4 h-4 text-red-500" />
      )}
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-2 opacity-50 hover:opacity-100 transition"
      >
        <RiCloseLine className="w-4 h-4" />
      </button>
    </div>
  );
};

/* ─── Stat Card ─── */
const StatCard = ({
  label,
  value,
  icon: Icon,
  accent = "border-emerald-100",
}) => (
  <div
    className={`bg-white border rounded-2xl px-5 py-4 flex items-center gap-4 shadow-sm ${accent}`}
  >
    <div className="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center flex-shrink-0">
      <Icon className="w-5 h-5 text-emerald-600" />
    </div>
    <div>
      <div className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
        {label}
      </div>
      <div className="text-lg font-extrabold text-slate-800">{value}</div>
    </div>
  </div>
);

/* ─── Branch-wise PDF Buttons ─── */
const PdfButton = ({ invoiceId, splitBillId, onError }) => {
  const [loading, setLoading] = useState(false);
  const handleClick = async (e) => {
    e.stopPropagation();
    setLoading(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/splitsbill/invoices/${invoiceId}/split-bill/${splitBillId}/pdf-data`,
      );
      const pdfData = res.data?.data;
      if (!pdfData) throw new Error("No data returned from PDF API");
      generateBranchWiseSplitBillPDF(pdfData);
    } catch (err) {
      onError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to generate PDF.",
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <button
      onClick={handleClick}
      disabled={loading}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border bg-red-50 border-red-200 text-red-600 hover:bg-red-600 hover:border-red-600 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-150 whitespace-nowrap"
    >
      {loading ? (
        <Spinner className="w-3.5 h-3.5" />
      ) : (
        <RiFilePdf2Line className="w-3.5 h-3.5" />
      )}
      {loading ? "Generating…" : "PDF"}
    </button>
  );
};

const BranchPdfButton = ({ invoiceId, firstSplitBillId, onError }) => {
  const [loading, setLoading] = useState(false);
  const handleClick = async (e) => {
    e.stopPropagation();
    setLoading(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/splitsbill/invoices/${invoiceId}/split-bill/${firstSplitBillId}/pdf-data`,
      );
      const pdfData = res.data?.data;
      if (!pdfData) throw new Error("No data returned from PDF API");
      generateBranchWiseSplitBillPDF(pdfData);
    } catch (err) {
      onError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to generate branch PDF.",
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <button
      onClick={handleClick}
      disabled={loading}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border bg-red-50 border-red-200 text-red-600 hover:bg-red-600 hover:border-red-600 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-150 whitespace-nowrap"
    >
      {loading ? (
        <Spinner className="w-3.5 h-3.5" />
      ) : (
        <RiFilePdf2Line className="w-3.5 h-3.5" />
      )}
      {loading ? "Generating…" : "PDF"}
    </button>
  );
};
/* ══════════════════════════════════════════════════════════════
   BORROWER PDF BUTTON  —  with / without table split dropdown
══════════════════════════════════════════════════════════════ */
async function buildBorrowerPdfData({ invoiceId, firstSplitBillId, borrower }) {
  const res = await axios.get(
    `${BASE_URL}/splitsbill/invoices/${invoiceId}/split-bill/${firstSplitBillId}/pdf-data`,
  );
  const pdfData = res.data?.data;
  if (!pdfData) throw new Error("No data returned from PDF API");

  const invoiceSubTotal = pdfData.invoice?.subTotal || 0;
  const borrowerRatio =
    invoiceSubTotal > 0 ? (borrower.subtotal || 0) / invoiceSubTotal : 0;

  return {
    ...pdfData,
    splitBill: {
      ...pdfData.splitBill,
      borrowers: [borrower],
      subTotal: borrower.subtotal ?? 0,
      cgst: borrower.cgst ?? 0,
      sgst: borrower.sgst ?? 0,
      total: borrower.total ?? 0,
    },
    items: {
      ...pdfData.items,
      allItems: (pdfData.items?.allItems || []).map((item) => ({
        ...item,
        splitAmount: Number(
          ((item.originalAmount || 0) * borrowerRatio).toFixed(2),
        ),
      })),
    },
  };
}

const BorrowerPdfButton = ({
  invoiceId,
  branchId,
  firstSplitBillId,
  borrower,
  onError,
}) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const generate = async (e, withTable) => {
    e.stopPropagation();
    setOpen(false);
    setLoading(true);
    try {
      const borrowerPdfData = await buildBorrowerPdfData({
        invoiceId,
        firstSplitBillId,
        borrower,
      });
      withTable
        ? generateBranchWiseSplitBillPDF(borrowerPdfData)
        : generateBranchWiseSplitBillPDFNoTable(borrowerPdfData);
    } catch (err) {
      onError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to generate borrower PDF.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      ref={menuRef}
      className="relative inline-flex"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={(e) => {
          e.stopPropagation();
          if (!loading) setOpen((prev) => !prev);
        }}
        disabled={loading}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border bg-red-50 border-red-200 text-red-600 hover:bg-red-600 hover:border-red-600 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-150 whitespace-nowrap"
      >
        {loading ? (
          <Spinner className="w-3.5 h-3.5" />
        ) : (
          <RiFilePdf2Line className="w-3.5 h-3.5" />
        )}
        {loading ? "Generating…" : "PDF"}
        {!loading && (
          <RiArrowDownSLine
            className={`w-3 h-3 transition-transform duration-150 ${open ? "rotate-180" : ""}`}
          />
        )}
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-1.5 z-50 min-w-[168px] bg-white border border-slate-200 rounded-xl shadow-lg overflow-hidden">
          <button
            onClick={(e) => generate(e, true)}
            className="w-full flex items-center gap-2.5 px-3.5 py-2.5 text-left text-[11px] font-semibold text-slate-700 hover:bg-red-50 hover:text-red-700 transition-colors"
          >
            <RiTableLine className="w-3.5 h-3.5 flex-shrink-0 text-red-400" />
            <span>With Table Split</span>
          </button>

          <div className="mx-3 border-t border-slate-100" />

          <button
            onClick={(e) => generate(e, false)}
            className="w-full flex items-center gap-2.5 px-3.5 py-2.5 text-left text-[11px] font-semibold text-slate-700 hover:bg-red-50 hover:text-red-700 transition-colors"
          >
            <RiFilePdf2Line className="w-3.5 h-3.5 flex-shrink-0 text-slate-400" />
            <span>Without Table Split</span>
          </button>
        </div>
      )}
    </div>
  );
};

/* ══════════════════════════════════════════════════════════════
   SIZE-WISE PDF BUTTONS
══════════════════════════════════════════════════════════════ */
const SizePdfBaseButton = ({
  label,
  icon: Icon,
  loading,
  onClick,
  variant = "size",
}) => {
  const colors =
    variant === "split"
      ? "bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-600 hover:border-emerald-600 hover:text-white"
      : "bg-indigo-50 border-indigo-200 text-indigo-700 hover:bg-indigo-600 hover:border-indigo-600 hover:text-white";

  return (
    <button
      onClick={onClick}
      disabled={loading}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-semibold border transition-all duration-150 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed ${colors}`}
    >
      {loading ? (
        <Spinner className="w-3.5 h-3.5" />
      ) : (
        <Icon className="w-3.5 h-3.5" />
      )}
      {loading ? "Generating…" : label}
    </button>
  );
};

const SizeCalcPdfButton = ({ bill, invoiceData, onError }) => {
  const [loading, setLoading] = useState(false);
  const handleClick = (e) => {
    e.stopPropagation();
    setLoading(true);
    try {
      generateSizeCalculationPDF(bill, invoiceData || {});
    } catch (err) {
      onError(err?.message || "Failed to generate size calculation PDF.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <SizePdfBaseButton
      label="Size PDF"
      icon={RiRulerLine}
      loading={loading}
      onClick={handleClick}
      variant="size"
    />
  );
};

const SizeSplitPdfButton = ({ bill, invoiceData, onError }) => {
  const [loading, setLoading] = useState(false);
  const handleClick = (e) => {
    e.stopPropagation();
    setLoading(true);
    try {
      generateSizeBranchSplitPDF(bill, invoiceData || {});
    } catch (err) {
      onError(err?.message || "Failed to generate split PDF.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <SizePdfBaseButton
      label="Split PDF"
      icon={RiSplitCellsHorizontal}
      loading={loading}
      onClick={handleClick}
      variant="split"
    />
  );
};

/* ══════════════════════════════════════════════════════════════
   SIZE ITEMS TAB
══════════════════════════════════════════════════════════════ */
const SizeItemsTab = ({ invoiceId, notify }) => {
  const [bills, setBills] = useState([]);
  const [invoiceData, setInvoiceData] = useState({});
  const [loading, setLoading] = useState(true);
  const [expandedBills, setExpandedBills] = useState({});

  useEffect(() => {
    const fetchBills = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${BASE_URL}/size-wise-split/${invoiceId}/size-split-bills`,
        );
        const data = res.data?.data || {};
        setBills(data.splitBills || []);
        if (data.invoice) setInvoiceData(data.invoice);
      } catch {
        notify("Failed to load size-wise split bills", "error");
      } finally {
        setLoading(false);
      }
    };
    fetchBills();
  }, [invoiceId]); // eslint-disable-line

  const toggleBill = (id) =>
    setExpandedBills((prev) => ({ ...prev, [id]: !prev[id] }));

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-20 gap-3 text-indigo-400">
        <Spinner className="w-8 h-8" />
        <span className="text-xs font-medium">Loading size items…</span>
      </div>
    );
  }

  if (bills.length === 0) {
    return (
      <div className="bg-white border border-indigo-100 rounded-2xl shadow-sm flex flex-col items-center justify-center py-20 gap-3">
        <RiInboxLine className="w-12 h-12 text-indigo-200" />
        <p className="text-sm font-semibold text-slate-400">
          No size-wise split bills found.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      {bills.map((bill, billIdx) => {
        const isOpen = expandedBills[bill._id] !== false;
        const hasBranches = bill.branches && bill.branches.length > 0;

        return (
          <div
            key={bill._id || billIdx}
            className="bg-white border border-indigo-100 rounded-2xl shadow-sm overflow-hidden"
          >
            {/* ── Bill header ── */}
            <div className="flex items-center justify-between px-5 py-3.5 bg-indigo-50/60 border-b border-indigo-100">
              <button
                onClick={() => toggleBill(bill._id)}
                className="flex items-center gap-3 text-left flex-1 min-w-0 hover:opacity-80 transition"
              >
                <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center text-white flex-shrink-0">
                  <RiRulerLine className="w-3.5 h-3.5" />
                </div>
                <div>
                  <span className="text-sm font-bold text-indigo-800">
                    Bill #{bill.billNumber}
                  </span>
                  <span className="ml-2 text-[10px] text-indigo-400 font-mono">
                    {bill.sizeItems?.length || 0} size row
                    {bill.sizeItems?.length !== 1 ? "s" : ""}
                    {hasBranches &&
                      ` · ${bill.branches.length} branch${bill.branches.length !== 1 ? "es" : ""}`}
                  </span>
                </div>
              </button>

              <div className="hidden sm:flex items-center gap-4 mr-3">
                {[
                  { label: "Sub Total", value: bill.grandSubTotal },
                  { label: "CGST", value: bill.grandCgst },
                  { label: "SGST", value: bill.grandSgst },
                  { label: "Total", value: bill.grandTotal, bold: true },
                ].map(({ label, value, bold }) => (
                  <div key={label} className="text-right">
                    <div className="text-[9px] text-slate-400 uppercase tracking-widest">
                      {label}
                    </div>
                    <div
                      className={`text-xs font-mono ${bold ? "font-extrabold text-indigo-700" : "font-semibold text-slate-700"}`}
                    >
                      ₹{fmt(value)}
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                {bill.sizeItems?.length > 0 && (
                  <SizeCalcPdfButton
                    bill={bill}
                    invoiceData={invoiceData}
                    onError={(msg) => notify(msg, "error")}
                  />
                )}
                {hasBranches && (
                  <SizeSplitPdfButton
                    bill={bill}
                    invoiceData={invoiceData}
                    onError={(msg) => notify(msg, "error")}
                  />
                )}
                <button
                  onClick={() => toggleBill(bill._id)}
                  className="ml-1 p-1 rounded-lg hover:bg-indigo-100 transition"
                >
                  <RiArrowRightSLine
                    className={`w-4 h-4 text-indigo-400 transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`}
                  />
                </button>
              </div>
            </div>

            {isOpen && (
              <>
                {/* ── Size Items table ── */}
                <div className="px-5 pt-4 pb-2">
                  <div className="flex items-center gap-2 mb-2">
                    <RiRulerLine className="w-3.5 h-3.5 text-indigo-400" />
                    <span className="text-[10px] font-bold text-indigo-600 uppercase tracking-widest">
                      Size Calculation Rows
                    </span>
                  </div>
                </div>

                <div className="overflow-x-auto">
                  <table className="w-full text-xs">
                    <thead>
                      <tr className="border-b border-indigo-50 bg-indigo-50/40">
                        {[
                          "#",
                          "Height",
                          "Common",
                          "Total Ht.",
                          "Width",
                          "Area (SqCm)",
                          "Rate",
                          "Sub Total",
                          "CGST",
                          "SGST",
                          "Total",
                        ].map((h) => (
                          <th
                            key={h}
                            className="px-4 py-2.5 text-left text-[10px] font-semibold text-indigo-500 uppercase tracking-widest whitespace-nowrap"
                          >
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {(bill.sizeItems || []).map((item, i) => (
                        <tr
                          key={item._id || i}
                          className="border-b border-slate-50 hover:bg-indigo-50/10 transition"
                        >
                          <td className="px-4 py-2.5 text-slate-400 font-mono">
                            {i + 1}
                          </td>
                          <td className="px-4 py-2.5 font-mono text-slate-700">
                            {item.height}
                          </td>
                          <td className="px-4 py-2.5 font-mono text-slate-500">
                            {item.common}
                          </td>
                          <td className="px-4 py-2.5 font-mono font-semibold text-indigo-700">
                            {item.totalHeight}
                          </td>
                          <td className="px-4 py-2.5 font-mono text-slate-700">
                            {item.width}
                          </td>
                          <td className="px-4 py-2.5 font-mono font-semibold text-slate-700">
                            {fmt(item.area)}
                          </td>
                          <td className="px-4 py-2.5 font-mono text-slate-600">
                            ₹{fmt(item.rate)}
                          </td>
                          <td className="px-4 py-2.5 font-mono text-slate-700">
                            ₹{fmt(item.subTotal)}
                          </td>
                          <td className="px-4 py-2.5 font-mono text-slate-500">
                            ₹{fmt(item.cgst)}
                          </td>
                          <td className="px-4 py-2.5 font-mono text-slate-500">
                            ₹{fmt(item.sgst)}
                          </td>
                          <td className="px-4 py-2.5 font-mono font-extrabold text-indigo-700">
                            ₹{fmt(item.total)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="bg-indigo-50/60 border-t-2 border-indigo-100">
                        <td
                          colSpan={7}
                          className="px-4 py-2.5 text-[10px] font-bold text-indigo-600 uppercase tracking-widest"
                        >
                          Grand Total ({bill.sizeItems?.length || 0} rows)
                        </td>
                        <td className="px-4 py-2.5 font-bold font-mono text-slate-700">
                          ₹{fmt(bill.grandSubTotal)}
                        </td>
                        <td className="px-4 py-2.5 font-bold font-mono text-slate-700">
                          ₹{fmt(bill.grandCgst)}
                        </td>
                        <td className="px-4 py-2.5 font-bold font-mono text-slate-700">
                          ₹{fmt(bill.grandSgst)}
                        </td>
                        <td className="px-4 py-2.5 font-extrabold font-mono text-indigo-700 text-sm">
                          ₹{fmt(bill.grandTotal)}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                {/* ── Branch & Borrower Allocation ── */}
                {hasBranches && (
                  <>
                    <div className="px-5 pt-4 pb-2 border-t border-slate-100 mt-2">
                      <div className="flex items-center gap-2 mb-2">
                        <RiBuilding2Line className="w-3.5 h-3.5 text-emerald-500" />
                        <span className="text-[10px] font-bold text-emerald-600 uppercase tracking-widest">
                          Branch &amp; Borrower Allocation
                        </span>
                      </div>
                    </div>

                    <div className="overflow-x-auto pb-4">
                      <table className="w-full text-xs">
                        <thead>
                          <tr className="border-b border-emerald-50 bg-emerald-50/40">
                            {[
                              "#",
                              "Branch",
                              "Borrower",
                              "Sub Total",
                              "CGST",
                              "SGST",
                              "Total",
                            ].map((h) => (
                              <th
                                key={h}
                                className="px-4 py-2.5 text-left text-[10px] font-semibold text-emerald-500 uppercase tracking-widest whitespace-nowrap"
                              >
                                {h}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {bill.branches.map((branch, bi) =>
                            (branch.borrowers || []).map((borrower, bwi) => (
                              <tr
                                key={`${bi}-${bwi}`}
                                className="border-b border-slate-50 hover:bg-emerald-50/10 transition"
                              >
                                <td className="px-4 py-2.5 text-slate-400 font-mono">
                                  {bi + 1}.{bwi + 1}
                                </td>
                                <td className="px-4 py-2.5">
                                  {bwi === 0 ? (
                                    <div className="flex items-center gap-1.5">
                                      <RiBuilding2Line className="w-3 h-3 text-emerald-400 flex-shrink-0" />
                                      <span className="font-semibold text-slate-700 whitespace-nowrap">
                                        {branch.branchName}
                                      </span>
                                      {branch.borrowers.length > 1 && (
                                        <span className="ml-1 px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-emerald-50 border border-emerald-200 text-emerald-600">
                                          {branch.borrowers.length}
                                        </span>
                                      )}
                                    </div>
                                  ) : (
                                    <span className="text-slate-300 pl-5">
                                      ↳
                                    </span>
                                  )}
                                </td>
                                <td className="px-4 py-2.5">
                                  <div className="flex items-center gap-1.5">
                                    <RiUserLine className="w-3 h-3 text-emerald-300 flex-shrink-0" />
                                    <span className="text-slate-600">
                                      {borrower.borrowerName || "—"}
                                    </span>
                                  </div>
                                </td>
                                <td className="px-4 py-2.5 font-mono text-slate-700">
                                  ₹{fmt(borrower.subtotal)}
                                </td>
                                <td className="px-4 py-2.5 font-mono text-slate-500">
                                  ₹{fmt(borrower.cgst)}
                                </td>
                                <td className="px-4 py-2.5 font-mono text-slate-500">
                                  ₹{fmt(borrower.sgst)}
                                </td>
                                <td className="px-4 py-2.5 font-mono font-extrabold text-emerald-700">
                                  ₹{fmt(borrower.total)}
                                </td>
                              </tr>
                            )),
                          )}
                        </tbody>
                        <tfoot>
                          <tr className="bg-emerald-50/60 border-t-2 border-emerald-100">
                            <td
                              colSpan={3}
                              className="px-4 py-2.5 text-[10px] font-bold text-emerald-600 uppercase tracking-widest"
                            >
                              Bill Total (
                              {bill.branches.reduce(
                                (s, b) => s + (b.borrowers?.length || 0),
                                0,
                              )}{" "}
                              borrowers)
                            </td>
                            <td className="px-4 py-2.5 font-bold font-mono text-slate-700">
                              ₹{fmt(bill.grandSubTotal)}
                            </td>
                            <td className="px-4 py-2.5 font-bold font-mono text-slate-700">
                              ₹{fmt(bill.grandCgst)}
                            </td>
                            <td className="px-4 py-2.5 font-bold font-mono text-slate-700">
                              ₹{fmt(bill.grandSgst)}
                            </td>
                            <td className="px-4 py-2.5 font-extrabold font-mono text-emerald-700 text-sm">
                              ₹{fmt(bill.grandTotal)}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </>
                )}

                {(bill.selectedBank?.branchName ||
                  bill.selectedQuery?.contactPersonName) && (
                  <div className="px-5 py-3 bg-slate-50 border-t border-slate-100 flex flex-wrap gap-6 text-[10px] text-slate-500">
                    {bill.selectedBank?.branchName && (
                      <div className="flex items-center gap-1.5">
                        <span className="font-bold text-slate-600">
                          {bill.selectedBank.branchName}
                        </span>
                        <span className="text-slate-300">·</span>
                        <span>{bill.selectedBank.accountNumber}</span>
                        <span className="text-slate-300">·</span>
                        <span>{bill.selectedBank.ifscCode}</span>
                      </div>
                    )}
                    {bill.selectedQuery?.contactPersonName && (
                      <div className="flex items-center gap-1.5">
                        <span>{bill.selectedQuery.contactPersonName}</span>
                        <span className="text-slate-300">·</span>
                        <span>{bill.selectedQuery.phone}</span>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

/* ══════════════════════════════════════════════════════════════
   BRANCH SPLITS TAB
══════════════════════════════════════════════════════════════ */
const BranchSplitsTab = ({ splits, summary, invoiceId, notify }) => {
  // Auto-expand single-borrower branches so the borrower row is visible immediately.
  // Multi-borrower branches start collapsed (user clicks to expand).
  const [expandedBranches, setExpandedBranches] = useState(() =>
    Object.fromEntries(
      splits.filter((s) => s.borrowers.length === 1).map((s) => [s.id, true]),
    ),
  );

  const toggleBranch = (splitId) =>
    setExpandedBranches((prev) => ({ ...prev, [splitId]: !prev[splitId] }));

  const totalSplitAmount = splits.reduce((s, b) => s + b.total, 0);

  if (splits.length === 0) {
    return (
      <div className="bg-white border border-emerald-100 rounded-2xl shadow-sm flex flex-col items-center justify-center py-20 gap-3">
        <RiInboxLine className="w-12 h-12 text-emerald-200" />
        <p className="text-sm font-semibold text-slate-400">
          No branch split bills found.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white border border-emerald-100 rounded-2xl shadow-sm overflow-hidden">
      <div className="px-5 py-3 border-b border-emerald-100 bg-emerald-50 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <RiSplitCellsHorizontal className="w-4 h-4 text-emerald-500" />
          <span className="text-xs font-bold text-emerald-700 uppercase tracking-widest">
            Branch Split Bills ({splits.length})
          </span>
        </div>
        {summary && (
          <span className="text-[10px] text-slate-400 font-medium">
            Remaining:{" "}
            <span
              className={`font-bold ${summary.remainingAmount === 0 ? "text-emerald-600" : "text-amber-600"}`}
            >
              ₹{fmt(summary.remainingAmount)}
            </span>
          </span>
        )}
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-emerald-100 bg-emerald-50/40">
              {[
                "#",
                "Branch / Borrowers",
                "Accounts",
                "Sub Total",
                "CGST",
                "SGST",
                "Total",
                "PDF",
              ].map((h) => (
                <th
                  key={h}
                  className="px-4 py-3 text-left text-[10px] font-semibold text-emerald-500 uppercase tracking-widest whitespace-nowrap"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {splits.map((split, gIdx) => {
              const isMulti = split.borrowers.length > 1;
              const isOpen = !!expandedBranches[split.id];

              return (
                <React.Fragment key={split.id || gIdx}>
                  {/* ── Branch row (always clickable to expand/collapse) ── */}
                  <tr
                    onClick={() => toggleBranch(split.id)}
                    className="border-b border-emerald-50 transition-colors cursor-pointer bg-emerald-50/20 hover:bg-emerald-50/50 select-none"
                  >
                    <td className="px-4 py-3 text-xs text-slate-400 font-mono">
                      {gIdx + 1}
                    </td>

                    <td className="px-4 py-3">
                      <div className="flex items-center gap-1.5">
                        {/* Expand/collapse chevron — always shown */}
                        <RiArrowRightSLine
                          className={`w-4 h-4 text-emerald-400 flex-shrink-0 transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`}
                        />
                        <RiBuilding2Line className="w-3.5 h-3.5 text-emerald-300 flex-shrink-0" />
                        <span className="text-xs font-semibold text-slate-700 whitespace-nowrap max-w-[140px] truncate">
                          {split.branchName}
                        </span>
                        {/* Borrower count badge — always shown */}
                        <span
                          className={`ml-1 inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-bold whitespace-nowrap
                            ${
                              isMulti
                                ? "bg-blue-50 border border-blue-200 text-blue-600"
                                : "bg-emerald-50 border border-emerald-200 text-emerald-600"
                            }`}
                        >
                          {split.borrowers.length} borrower
                          {split.borrowers.length !== 1 ? "s" : ""}
                        </span>
                      </div>
                    </td>

                    <td className="px-4 py-3 text-xs font-mono text-slate-600">
                      {split.acc.toLocaleString("en-IN")}
                    </td>
                    <td className="px-4 py-3 text-xs font-mono text-slate-600">
                      ₹{fmt(split.subTotal)}
                    </td>
                    <td className="px-4 py-3 text-xs font-mono text-slate-500">
                      ₹{fmt(split.cgst)}
                    </td>
                    <td className="px-4 py-3 text-xs font-mono text-slate-500">
                      ₹{fmt(split.sgst)}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <span className="font-extrabold text-emerald-700 font-mono text-sm">
                        ₹{fmt(split.total)}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      {/* Branch-level PDF (full branch, all borrowers) */}
                      {isMulti ? (
                        <BranchPdfButton
                          invoiceId={invoiceId}
                          firstSplitBillId={split.id}
                          onError={(msg) => notify(msg, "error")}
                        />
                      ) : (
                        <PdfButton
                          invoiceId={invoiceId}
                          splitBillId={split.id}
                          onError={(msg) => notify(msg, "error")}
                        />
                      )}
                    </td>
                  </tr>

                  {/* ── Borrower sub-rows — shown for ALL branches (1 or many) ── */}
                  {isOpen &&
                    split.borrowers.map((b, bi) => (
                      <tr
                        key={bi}
                        className="border-b border-blue-50 bg-blue-50/20 hover:bg-blue-50/40 transition-colors"
                      >
                        <td className="px-4 py-2.5 text-[10px] text-slate-400 font-mono">
                          {gIdx + 1}.{bi + 1}
                        </td>
                        <td className="px-4 py-2.5">
                          <div className="flex items-center gap-1.5 pl-9">
                            <RiUserLine className="w-3 h-3 text-emerald-300 flex-shrink-0" />
                            <span className="text-xs text-slate-600 whitespace-nowrap max-w-[130px] truncate">
                              {b.borrowerName}
                            </span>
                          </div>
                        </td>
                        <td className="px-4 py-2.5 text-xs font-mono text-slate-600">
                          {Number(b.accountNumber).toLocaleString("en-IN")}
                        </td>
                        <td className="px-4 py-2.5 text-xs font-mono text-slate-600">
                          ₹{fmt(b.subtotal)}
                        </td>
                        <td className="px-4 py-2.5 text-xs font-mono text-slate-500">
                          ₹{fmt(b.cgst)}
                        </td>
                        <td className="px-4 py-2.5 text-xs font-mono text-slate-500">
                          ₹{fmt(b.sgst)}
                        </td>
                        <td className="px-4 py-2.5 whitespace-nowrap">
                          <span className="font-bold text-emerald-700 font-mono text-xs">
                            ₹{fmt(b.total)}
                          </span>
                        </td>
                        <td className="px-4 py-2.5">
                          {/* Borrower-level PDF with with/without table dropdown */}
                          <BorrowerPdfButton
                            invoiceId={invoiceId}
                            firstSplitBillId={split.id}
                            borrower={b}
                            onError={(msg) => notify(msg, "error")}
                          />
                        </td>
                      </tr>
                    ))}
                </React.Fragment>
              );
            })}
          </tbody>
          <tfoot>
            <tr className="bg-emerald-50/60 border-t-2 border-emerald-100">
              <td
                colSpan={2}
                className="px-4 py-3 text-xs font-bold text-emerald-700 uppercase tracking-widest"
              >
                Totals ({splits.length} split{splits.length !== 1 ? "s" : ""})
              </td>
              <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700">
                {splits.reduce((s, b) => s + b.acc, 0).toLocaleString("en-IN")}
              </td>
              <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700">
                ₹
                {fmt(
                  summary?.totalSubTotal ??
                    splits.reduce((s, b) => s + b.subTotal, 0),
                )}
              </td>
              <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700">
                ₹
                {fmt(
                  summary?.totalCGST ?? splits.reduce((s, b) => s + b.cgst, 0),
                )}
              </td>
              <td className="px-4 py-3 text-xs font-bold font-mono text-slate-700">
                ₹
                {fmt(
                  summary?.totalSGST ?? splits.reduce((s, b) => s + b.sgst, 0),
                )}
              </td>
              <td className="px-4 py-3">
                <span className="font-extrabold text-emerald-800 font-mono text-base">
                  ₹{fmt(summary?.totalAmount ?? totalSplitAmount)}
                </span>
              </td>
              <td />
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════════════════════════════ */
const TABS = [
  { id: "branch", label: "Branch Splits", icon: RiSplitCellsHorizontal },
  { id: "size", label: "Size Items", icon: RiRulerLine },
];

const SplitBillDetails = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const invoiceData = state?.invoiceData || null;

  const [splits, setSplits] = useState([]);
  const [summary, setSummary] = useState(null);
  const [invoice, setInvoice] = useState(invoiceData);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);
  const [activeTab, setActiveTab] = useState("branch");

  const notify = (message, type = "success") => setToast({ message, type });

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/splitsbill/${id}/split-bills`);
      const raw = res.data?.data || {};

      if (raw.invoice) setInvoice(raw.invoice);

      const type = raw.splitBillType;

      if (type === "branch" || type === "both") {
        const rawList = raw.allSplitBills || raw.splitBills || [];
        setSplits(rawList.map((item, i) => normalizeSplit(item, i)));
        if (raw.summary) setSummary(raw.summary);
        setActiveTab("branch");
      } else if (type === "size") {
        setSplits([]);
        setSummary(null);
        setActiveTab("size");
      } else {
        setSplits([]);
        setSummary(null);
      }
    } catch {
      notify("Failed to load split bills for this invoice", "error");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const inv = invoice;
  const totalSplitAmount = splits.reduce((s, b) => s + b.total, 0);
  const totalAccounts = splits.reduce((s, b) => s + b.acc, 0);

  const splitBillType = inv?.splitBillType;

  const visibleTabs =
    splitBillType === "branch"
      ? TABS.filter((t) => t.id === "branch")
      : splitBillType === "size"
        ? TABS.filter((t) => t.id === "size")
        : TABS;

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4 text-emerald-400">
          <Spinner className="w-10 h-10" />
          <span className="text-sm font-medium">
            Loading split bill details…
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      {/* Header */}
      <header className="bg-white border-b border-emerald-100 sticky top-0 z-30 shadow-sm">
        <div className="w-full px-6 py-3.5 flex items-center gap-4 flex-wrap">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center w-9 h-9 rounded-xl border border-emerald-200 bg-emerald-50 text-emerald-600 hover:bg-emerald-100 transition flex-shrink-0"
          >
            <RiArrowLeftLine className="w-4 h-4" />
          </button>

          <div className="flex items-center gap-3 flex-1 min-w-0">
            <div className="w-10 h-10 rounded-xl bg-emerald-600 flex items-center justify-center text-white shadow-md shadow-emerald-200 flex-shrink-0">
              <RiSplitCellsHorizontal className="w-5 h-5" />
            </div>
            <div className="min-w-0">
              <h1 className="text-base font-bold text-emerald-800 tracking-tight">
                Split Bill Details
                {inv?.invoiceNumber && (
                  <span className="ml-2 text-emerald-500 font-mono text-sm">
                    — {inv.invoiceNumber}
                  </span>
                )}
              </h1>
              <p className="text-[11px] text-emerald-400 tracking-widest uppercase">
                {inv?.releaseOrder?.roNumber
                  ? `RO: ${inv.releaseOrder.roNumber}`
                  : "Invoice Split Bills"}
              </p>
            </div>
          </div>

          <div className="hidden sm:flex items-center gap-2 flex-wrap">
            {inv?.splitBillType && (
              <span className="inline-flex items-center gap-1 px-3 py-1.5 bg-indigo-50 border border-indigo-200 rounded-full text-xs font-bold text-indigo-700 capitalize">
                <RiStackLine className="w-3 h-3" />
                {inv.splitBillType === "both"
                  ? "Branch + Size"
                  : `${inv.splitBillType}-wise`}
              </span>
            )}
            {inv?.splitBillStatus && (
              <span className="inline-flex items-center gap-1 px-3 py-1.5 bg-emerald-100 border border-emerald-200 rounded-full text-xs font-bold text-emerald-700">
                <RiCheckLine className="w-3 h-3" />
                {inv.splitBillStatus.charAt(0).toUpperCase() +
                  inv.splitBillStatus.slice(1)}
              </span>
            )}
            {inv?.date && (
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-slate-50 border border-slate-200 rounded-full text-xs font-semibold text-slate-600">
                <RiCalendarLine className="w-3.5 h-3.5 text-slate-400" />
                {fmtDate(inv.date)}
              </span>
            )}
          </div>
        </div>
      </header>

      <div className="px-6 py-6 space-y-5 w-full">
        {/* Invoice Summary */}
        {inv && (
          <div className="bg-white border border-emerald-100 rounded-2xl shadow-sm overflow-hidden">
            <div className="px-5 py-3 bg-emerald-50 border-b border-emerald-100 flex items-center gap-2">
              <RiFileTextLine className="w-4 h-4 text-emerald-500" />
              <span className="text-xs font-bold text-emerald-700 uppercase tracking-widest">
                Invoice Summary
              </span>
            </div>
            <div className="px-5 py-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-8 gap-y-4">
              {[
                { label: "Invoice No.", value: inv.invoiceNumber, mono: true },
                { label: "Date", value: fmtDate(inv.date || inv.createdAt) },
                {
                  label: "Sub Total",
                  value: `₹${fmt(inv.subTotal)}`,
                  mono: true,
                },
                {
                  label: "CGST",
                  value: `₹${fmt(inv.cgstAmount)}`,
                  sub: `${inv.cgstRate}%`,
                  mono: true,
                },
                {
                  label: "SGST",
                  value: `₹${fmt(inv.sgstAmount)}`,
                  sub: `${inv.sgstRate}%`,
                  mono: true,
                },
              ].map(({ label, value, sub, mono }) => (
                <div key={label}>
                  <div className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-0.5">
                    {label}
                  </div>
                  <div
                    className={`text-sm font-bold text-slate-800 ${mono ? "font-mono" : ""}`}
                  >
                    {value}
                  </div>
                  {sub && (
                    <div className="text-[10px] text-slate-400">{sub}</div>
                  )}
                </div>
              ))}
            </div>
            <div className="px-5 py-3 bg-emerald-600 flex items-center justify-between">
              <span className="text-xs font-bold text-emerald-100 uppercase tracking-widest">
                Total Invoice Amount
              </span>
              <span className="text-lg font-extrabold text-white font-mono">
                ₹{fmt(inv.totalAmount)}
              </span>
            </div>
          </div>
        )}

        {/* Stat Cards */}
        {splits.length > 0 && (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <StatCard
              label="Total Splits"
              value={summary?.totalSplitBills ?? splits.length}
              icon={RiSplitCellsHorizontal}
            />
            <StatCard
              label="Total Accounts"
              value={totalAccounts.toLocaleString("en-IN")}
              icon={RiHashtag}
            />
            <StatCard
              label="Split Amount"
              value={`₹${fmt(summary?.totalAmount ?? totalSplitAmount)}`}
              icon={LiaRupeeSignSolid}
            />
            <StatCard
              label="Remaining"
              value={`₹${fmt(summary?.remainingAmount ?? 0)}`}
              icon={RiPieChartLine}
              accent={
                (summary?.remainingAmount ?? 0) === 0
                  ? "border-emerald-200"
                  : "border-amber-200"
              }
            />
          </div>
        )}

        {/* Tabs */}
        {visibleTabs.length > 1 && (
          <div className="flex items-center gap-1 bg-white border border-slate-200 rounded-xl p-1 w-fit shadow-sm">
            {visibleTabs.map((tab) => {
              const Icon = tab.icon;
              const active = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-bold transition-all duration-150
                    ${
                      active
                        ? tab.id === "size"
                          ? "bg-indigo-600 text-white shadow-sm"
                          : "bg-emerald-600 text-white shadow-sm"
                        : "text-slate-500 hover:text-slate-700 hover:bg-slate-50"
                    }`}
                >
                  <Icon className="w-3.5 h-3.5" />
                  {tab.label}
                  {tab.id === "branch" && splits.length > 0 && (
                    <span
                      className={`px-1.5 py-0.5 rounded-full text-[10px] font-extrabold
                      ${active ? "bg-white/20 text-white" : "bg-slate-100 text-slate-500"}`}
                    >
                      {splits.length}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        )}

        {/* Tab content */}
        {activeTab === "branch" && (
          <BranchSplitsTab
            splits={splits}
            summary={summary}
            invoiceId={id}
            notify={notify}
          />
        )}
        {activeTab === "size" && (
          <SizeItemsTab invoiceId={id} notify={notify} />
        )}
      </div>

      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
};

export default SplitBillDetails;
